module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "id": "page__customer"
    }
  }, [_c('template', {
    slot: "header-left"
  }, [_c('div', {
    staticClass: "page__customer__header-left"
  }, [_c('div', {
    staticClass: "page__customer__debt"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense close small page__customer__debt-btn",
    on: {
      "click": _vm.getDebt
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt"
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top",
      "md-delay": "500"
    }
  }, [_vm._v("Обновить сальдо")])], 1), _vm._v("\n\n                Сальдо: "), _c('b', {
    class: {
      'value': true, 'plus': parseFloat(_vm.customer.debt_sum) > 0, 'minus': parseFloat(_vm.customer.debt_sum) < 0
    }
  }, [_vm._v(" " + _vm._s(((_vm.price.format(_vm.customer.debt_sum)) + " руб.")))])], 1), _vm._v(" "), (_vm.customer.hid) ? _c('span', [_vm._v(" Реквизиты успешно проверены ")]) : _vm._e(), _vm._v(" "), (!_vm.customer.hid && parseInt(_vm.customer.type) != 2) ? _c('span', [_vm._v(" Реквизиты не были проверены!")]) : _vm._e()])]), _vm._v(" "), _c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), ((typeof _vm.customer.id !== 'undefined')) ? _c('template', {
    slot: "default"
  }, [(_vm.customer.id) ? _c('flex-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "min": "",
      "prevent-input": ""
    },
    on: {
      "change": _vm.changeActiveTab
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }) : _vm._e(), _vm._v(" "), _c('customer-information', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-information'),
      expression: "activeTab == 'tab-information'"
    }],
    ref: "information",
    model: {
      value: (_vm.customer),
      callback: function($$v) {
        _vm.customer = $$v
      },
      expression: "customer"
    }
  }), _vm._v(" "), _c('customer-address', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-address'),
      expression: "activeTab == 'tab-address'"
    }],
    attrs: {
      "customer-id": parseInt(_vm.customer.id)
    },
    model: {
      value: (_vm.customer.addresses),
      callback: function($$v) {
        _vm.$set(_vm.customer, "addresses", $$v)
      },
      expression: "customer.addresses"
    }
  }), _vm._v(" "), _c('customer-contacts', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-contacts'),
      expression: "activeTab == 'tab-contacts'"
    }],
    ref: "contacts",
    attrs: {
      "customer-id": parseInt(_vm.customer.id)
    },
    model: {
      value: (_vm.customer.contacts),
      callback: function($$v) {
        _vm.$set(_vm.customer, "contacts", $$v)
      },
      expression: "customer.contacts"
    }
  }), _vm._v(" "), (_vm.customer.id && _vm.activeTab == 'tab-finance') ? _c('customer-finance', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-finance'),
      expression: "activeTab == 'tab-finance'"
    }],
    attrs: {
      "customer-id": parseInt(_vm.customer.id)
    }
  }) : _vm._e(), _vm._v(" "), _c('comments-and-logs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-history'),
      expression: "activeTab == 'tab-history'"
    }],
    ref: "history",
    attrs: {
      "entity_id": parseInt(_vm.customer.id),
      "entity": _vm.historyEntity,
      "module": "customers"
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79a140f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/customers/views/Customer.vue
// module id = 1202
// module chunks = 0